"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.throttle"));

var _react = require("react");

var _checkVisibility = _interopRequireDefault(require("./checkVisibility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var throttleInterval = 150;

var useVisibility = function useVisibility(el) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$partial = _ref.partial,
      partial = _ref$partial === void 0 ? false : _ref$partial,
      _ref$scrollableEl = _ref.scrollableEl,
      scrollableEl = _ref$scrollableEl === void 0 ? window : _ref$scrollableEl;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setIsVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    var handleScrollOrResize = (0, _lodash["default"])(function () {
      return setIsVisible((0, _checkVisibility["default"])(el, partial));
    }, throttleInterval);
    scrollableEl.addEventListener('scroll', handleScrollOrResize);
    window.addEventListener('resize', handleScrollOrResize);
    setIsVisible((0, _checkVisibility["default"])(el, partial));
    return function () {
      scrollableEl.removeEventListener('scroll', handleScrollOrResize);
      window.removeEventListener('resize', handleScrollOrResize);
    };
  }, [el, partial, scrollableEl]);
  return isVisible;
};

var _default = useVisibility;
exports["default"] = _default;